<template lang="pug">
  ods-dropdown(:hide-on-click='false'
  icon='setting'
  @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
export default {
  name: 'b2b-table-menu-servicios-empresas',
  props: [],
  data () {
    return {
      columns: [],
      column: {},
      withProject: true
    }
  },
  computed: {
    isShowNameServiceParty () {
      return this.$store.getters.isShowNameServiceParty
    },
    isShowTaxServiceParty () {
      return this.$store.getters.isShowTaxServiceParty
    },
    isShowEnabledServiceParty () {
      return this.$store.getters.isShowEnabledServiceParty
    },
    isShowCountryServiceParty () {
      return this.$store.getters.isShowCountryServiceParty
    },
    isShowSellerServiceParty () {
      return this.$store.getters.isShowSellerServiceParty
    },
    isShowBuyerServiceParty () {
      return this.$store.getters.isShowBuyerServiceParty
    },
    isShowThirdServiceParty () {
      return this.$store.getters.isShowThirdServiceParty
    },
    isShowSponsorServiceParty () {
      return this.$store.getters.isShowSponsorServiceParty
    },
    isShowProvinceServiceParty () {
      return this.$store.getters.isShowProvinceServiceParty
    },
    isShowCreationDateTimeServiceParty () {
      return this.$store.getters.isShowCreationDateTimeServiceParty
    },
    isShowRegisterServiceParty () {
      return this.$store.getters.isShowRegisterServiceParty
    }
  },

  methods: {
    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      switch (column) {
        case 'nombre':
          this.$store.dispatch('isShowNameServiceParty', !this.$store.getters.isShowNameServiceParty)
          break
        case 'idfiscal':
          this.$store.dispatch('isShowTaxServiceParty', !this.$store.getters.isShowTaxServiceParty)
          break
        case 'pais':
          this.$store.dispatch('isShowCountryServiceParty', !this.$store.getters.isShowCountryServiceParty)
          break
        case 'provincia':
          this.$store.dispatch('isShowProvinceServiceParty', !this.$store.getters.isShowProvinceServiceParty)
          break
        case 'fecha':
          this.$store.dispatch('isShowCreationDateTimeServiceParty', !this.$store.getters.isShowCreationDateTimeServiceParty)
          break
        case 'vendedor':
          this.$store.dispatch('isShowSellerServiceParty', !this.$store.getters.isShowSellerServiceParty)
          break
        case 'comprador':
          this.$store.dispatch('isShowBuyerServiceParty', !this.$store.getters.isShowBuyerServiceParty)
          break
        case 'tercero':
          this.$store.dispatch('isShowThirdServiceParty', !this.$store.getters.isShowThirdServiceParty)
          break
        case 'sponsor':
          this.$store.dispatch('isShowSponsorServiceParty', !this.$store.getters.isShowSponsorServiceParty)
          break
        case 'registro':
          this.$store.dispatch('isShowRegisterServiceParty', !this.$store.getters.isShowRegisterServiceParty)
          break
        case 'estado':
          this.$store.dispatch('isShowEnabledServiceParty', !this.$store.getters.isShowEnabledServiceParty)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      if (this.withProject) {
        this.columns = [
          {
            text: this.$t('parties.entity_table.name'), value: 'nombre', show: this.isShowNameServiceParty
          }, {
            text: this.$t('parties.entity_table.identification_tax_number'), value: 'idfiscal', show: this.isShowTaxServiceParty
          }, {
            text: this.$t('parties.entity_table.country'), value: 'pais', show: this.isShowCountryServiceParty
          }, {
            text: this.$t('parties.entity_table.province'), value: 'provincia', show: this.isShowProvinceServiceParty
          }, {
            text: this.$t('parties.entity_table.creation_date'), value: 'fecha', show: this.isShowCreationDateTimeServiceParty
          }, {
            text: this.$t('parties.entity_table.seller'), value: 'vendedor', show: this.isShowSellerServiceParty
          }, {
            text: this.$t('parties.entity_table.buyer'), value: 'comprador', show: this.isShowBuyerServiceParty
          }, {
            text: this.$t('parties.entity_table.third'), value: 'tercero', show: this.isShowThirdServiceParty
          }, {
            text: this.$t('parties.entity_table.sponsor'), value: 'sponsor', show: this.isShowSponsorServiceParty
          }, {
            text: this.$t('parties.entity_table.register_location_company'), value: 'registro', show: this.isShowRegisterServiceParty
          }, {
            text: this.$t('parties.entity_table.enable'), value: 'estado', show: this.isShowEnabledServiceParty
          }
        ]
      } else {
        this.columns = [
          {
            text: this.$t('parties.entity_table.name'), value: 'nombre', show: this.isShowNameServiceParty
          }, {
            text: this.$t('parties.entity_table.identification_tax_number'), value: 'idfiscal', show: this.isShowTaxServiceParty
          }, {
            text: this.$t('parties.entity_table.country'), value: 'pais', show: this.isShowCountryServiceParty
          }, {
            text: this.$t('parties.entity_table.province'), value: 'provincia', show: this.isShowProvinceServiceParty
          }, {
            text: this.$t('parties.entity_table.creation_date_party'), value: 'fecha', show: this.isShowCreationDateTimeServiceParty
          }, {
            text: this.$t('parties.entity_table.register_location_company'), value: 'registro', show: this.isShowRegisterServiceParty
          }, {
            text: this.$t('parties.entity_table.enable'), value: 'estado', show: this.isShowEnabledServiceParty
          }
        ]
      }
      console.log('columns ', this.columns)
      console.log('columns.length ', this.columns.length)
    }
  },
  created () {
    this.withProject = (this.$route.params.projectId !== undefined && this.$route.params.projectId !== null)
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
.ods-dropdown {
    display: flex;
}
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
